import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { formatDateTimeAMPMCell, formatTimeCellToMin, getDate } from 'app/modules/shared/utility-functions/grid';
import * as CryptoJS from 'crypto-js';
import * as momentImported from 'moment';
import 'moment-timezone';
const moment = (momentImported as any).default || momentImported;

export interface EventFormatContext {
  eventId: string | null;
  timezone: string;
  dateFormat: string;
  timeFormat: string;
  distanceUnit: string;
  defaultCountryCode: string;
  momentDateFormat: string;
  momentTimeFormat: string;
  primeNgDateFormat: string;
  primeNgTimeFormat: string;
  hourFormat: '12' | '24';
  timeShowSeconds: boolean;
}
import { Observable, Subject, of } from 'rxjs';
import { RestApiService } from '../../shared/services/rest-api.service';
import { AppSettings } from './../../shared/app.settings';
import { StorageService } from './../../shared/services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class CommonBindingDataService {
  previousScrollTop;
  accesses: any;
  manualBookingData: any = {};
  rideType: any;
  secretKey = AppSettings.SECRET_KEY;
  public onHover = new Subject<any>();
  public isRouteDraw = new Subject<any>();

  public redrawSidebar: Subject<any> = new Subject<any>();
  public bookingTabCountChange = new Subject<any>();
  public eventId = new Subject<any>();
  public timeZone = new Subject<any>();
  public events = new Subject<any>();

  public checkLoginUser = new Subject<any>();

  public changedEventId;
  public bookingGridRefresh = new Subject<any>();
  public hideAssignButton = new Subject<any>();
  public selectedDriverData = new Subject<any>();
  public selectedBusData = new Subject<any>();

  public callListApi = new Subject<any>();
  public openMergePopupSubject = new Subject<any>();

  private readonly DEFAULT_DATE_FORMAT = 'dd MMM yyyy';
  private readonly DEFAULT_TIME_FORMAT = AppSettings.DEFAULT_TIME_FORMATE;
  private readonly DEFAULT_DISTANCE_UNIT = 'KM';
  private readonly DEFAULT_TIMEZONE = 'UTC';
  private readonly TENANT_TIME_FORMAT_KEY = 'time_format';

  constructor(
    private restApiService: RestApiService,
    private storageService: StorageService,
    private translateService: TranslateService

  ) {

  }

  getServiceType(): Observable<any> {
    if (this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE) !== null) {
      return of(this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE));
    } else {
      return this.restApiService.get('/secure/service-types?clientType=WEB');
    }
  }

  toGMT(now) {
    return new Date(now.getTime() - (now.getTimezoneOffset() * 60000)).getTime();
  }

  toGMTTime(time) {
    const offset = new Date().getTimezoneOffset() * 60000;
    const gmtTime = time + offset
    if (gmtTime >= 0) {
      return gmtTime;
    } else {
      return ((24 * 3600000) + gmtTime - 1);
    }
  }

  toGMTTime1(time) {
    const offset = new Date().getTimezoneOffset() * 60000;
    const gmtTime = time + offset
    if (gmtTime >= 0) {
      return gmtTime;
    } else {
      return ((24 * 3600000) + gmtTime);
    }
  }

  toGMTTimeOnly(time) {
    const offset = new Date().getTimezoneOffset() * 60000;
    let gmtTime = time + offset;
    if (gmtTime >= 24 * 3600000) {
      gmtTime = gmtTime - 24 * 3600000;
    } if (gmtTime < 0) {
      gmtTime = 24 * 3600000 + gmtTime;
    }

    if (gmtTime > 0) {
      return gmtTime;
    } else if (gmtTime === 0) {
      return ((24 * 3600000) + gmtTime);
    } else {
      return ((24 * 3600000) + gmtTime - 1);
    }
  }

  toCurrentTime(time) {
    const offset = new Date().getTimezoneOffset() * 60000;
    const gmtTime = time - offset
    if (gmtTime >= 24 * 3600000) {
      return (gmtTime - 24 * 3600000);
    } else {
      return gmtTime;
    }
  }

  toLocalTime(miliSeconds) {
    const now = new Date(miliSeconds);
    return new Date(miliSeconds + now.getTimezoneOffset() * 60000).getTime();
  }

  toLocalDate(miliSeconds) {
    const now = new Date(miliSeconds);
    return new Date(miliSeconds + now.getTimezoneOffset() * 60000);
  }

  unitConversionMToKm(m) {
    const results = m / 1000;
    if (results > 0) {
      return results.toFixed(2) + ' ';
    } else {
      return 0;
    }
  }

  unitConversionKMToM(km) {
    const results = km * 1000;
    if (results > 0) {
      return results.toFixed(2);
    } else {
      return 0;
    }
  }

  unitConversionKMToM1(km) {
    const results = km * 1000;
    if (results > 0) {
      return results;
    } else {
      return 0;
    }
  }

  unitConversionMinToMiliseconds(min) {
    const results = ((min * 60) * 1000);
    if (results > 0) {
      return results;
    } else {
      return 0;
    }
  }

  unitConversionmillisToTime(ms) {
    let seconds = (Math.floor((ms / 1000) % 60)),
      minutes = Math.floor((ms / (1000 * 60)) % 60),
      hours = Math.floor((ms / (1000 * 60 * 60)) % 24);

    let convertedHours = (hours < 10) ? "0" + hours : hours;
    let convertedMinutes = (minutes < 10) ? minutes : minutes;

    if (hours >= 1) {
      return convertedHours + ' Hour(s) ' + convertedMinutes + ' Min(s)';
    }
    if (minutes < 60) {
      if (minutes < 1) {
        return 1 + ' Min(s)';
      }
      return convertedMinutes + ' Min(s)';
    }
  }

  getBookLaterMinTime(serviceType, subcode) {
    const extraTime = this.getSpecificTimeout(serviceType, subcode);
    return new Date((new Date).getTime() + extraTime);
  }

  unitConversionMilisecondsToMin(mili) {
    const results = ((mili / 60) / 1000);
    if (results > 0) {
      return results;
    } else {
      return 0;
    }
  }

  meterToDefaultDistanceType(meter: any, distanceUnit?: string) {
    if (meter !== null && !isNaN(meter)) {
      if (distanceUnit?.toUpperCase() === 'KM') {
        return  Number((meter / 1000).toFixed(2));
      } else if(distanceUnit?.toUpperCase() === 'MILES' || distanceUnit?.toUpperCase() === 'MI') {
        return Number((meter / 1609.34).toFixed(2));
      } else {
        return Number((meter / 1000).toFixed(2));
      }
    }

    return 0;
  }

  kilometerOrMilesToDefaultDistanceType(km: any, distanceUnit?: string) {
    if (km !== null) {
      if (distanceUnit?.toUpperCase() === 'KM') {
        return Number((km * 1000).toFixed(2));
      } else if(distanceUnit?.toUpperCase() === 'MILES' || distanceUnit?.toUpperCase() === 'MI') {
        return Number((km * 1609.34).toFixed(2));
      } else {
        return Number((km * 1000).toFixed(2));
      }
    }

    return 0;
  }

  addLapseTimeInEndDate(endDate) {
    return endDate + AppSettings.twentyThreeFiftyNineLapse;
  }
  adjustDateToTimezone(date: Date, timeZone: string): Date {
    return new Date(date.toLocaleString('en-US', { timeZone }));
  }

  centerLatLng(dropPoints) {
    if (dropPoints.lenght === 0) {
      return 0;
    }
    const latArray = [];
    const lngArray = [];
    for (const points of dropPoints) {
      latArray.push(points.lat);
      lngArray.push(points.lng);
    }
    return this.findCenterDashLatLng(lngArray, latArray);
  }

  findCenterDashLatLng(lngArray, latArray) {
    const x1 = this.findMinMaxValue('min', lngArray);
    const x2 = this.findMinMaxValue('max', lngArray);
    const y1 = this.findMinMaxValue('min', latArray);
    const y2 = this.findMinMaxValue('max', latArray);
    const centerPoly = {
      lat: y1 + ((y2 - y1) / 2),
      lng: x1 + ((x2 - x1) / 2)
    };
    return centerPoly;
  }

  findMinMaxValue(type, data) {
    if (type === 'max') {
      return Math.max.apply(null, data);
    } else {
      return Math.min.apply(null, data);
    }
  }

  getServiceTypeKey(id) {
    let serviceType, serviceTypeId;
    if (this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE) !== null) {
      serviceType = this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE);
      serviceType.forEach(element => {
        if (element.id === id) {
          serviceTypeId = element.serviceType;
        }
      });
    }
    return serviceTypeId;
  }

  getTenantConfigValue(configKey) {
    let tenantConfig: any;
    tenantConfig = this.storageService.getItemFromSessionStorage(AppSettings.TENANT_CONFIG);
    if (tenantConfig) {
      for (let index = 0; index < tenantConfig.length; index++) {
        if (tenantConfig[index].configKey === configKey) {
          return tenantConfig[index].configValue;
        }
      }
    }
    return null;
  }

  getServiceTypeCodeBy(id) {
    let serviceType, code;
    if (this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE) !== null) {
      serviceType = this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE);
      serviceType.forEach(element => {
        if (element.id === id) {
          code = element.code;
        }
      });
    }
    return code;
  }

  getServiceTypeByCode(code) {
    let serviceType;
    const serviceTypeByCode = [];
    if (this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE) !== null) {
      serviceType = this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE);
      serviceType.forEach(element => {
        if (element.code === code) {
          serviceTypeByCode.push(element);
        }
      });
    }
    return serviceTypeByCode;
  }

  getServiceTypeId(key) {
    let serviceType, serviceTypeId;
    if (this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE) !== null) {
      serviceType = this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE);
      serviceType.forEach(element => {
        if (element.serviceType === key) {
          serviceTypeId = element.id;
        }
      });
    }
    return serviceTypeId;
  }

  removeGivenServiceTypefromList(key, serviceTypeList?) {
    let serviceTypes;
    if (serviceTypeList) {
      serviceTypes = serviceTypeList;
    } else {
      serviceTypes = this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_TYPE);
    }
    serviceTypes.forEach((item, index) => {
      if (key === item.subCode) {
        serviceTypes.splice(index, 1);
      }
    });
    return serviceTypes;
  }

  getSpecificTimeout(code, subcode) {
    const timeouts = this.storageService.getItemFromSessionStorage(AppSettings.TIME_SETTINGS);
    if (timeouts !== null) {
      for (const item of timeouts[code]) {
        if (item.key === subcode) {
          return parseInt(item.value, 10);
        }
      }
    }
  }

  getServiceTypeOnLogin(): Observable<any> {
    return this.restApiService.get('/secure/service-types?clientType=WEB', 'page-center');
  }

  getLocationsForDashboardMap(queueLocaationcatId): Observable<any> {
    return this.restApiService.get(`/secure/locations?projection=grid&isLimit=false&` +
      `locationCategoryId=${queueLocaationcatId}&activated=true`, 'page-center');
  }

  getDocumentType(eventId?): Observable<any> {
    return this.restApiService.get(`/secure/driver-document-types?eventId=${eventId ? eventId : ''}`, 'page-center');
  }

  getVehicleType(eventId?): Observable<any> {
    return this.restApiService.get(`/secure/vehicle-types?eventId=${eventId}`, 'page-center');
  }

  getDurationType(): Observable<any> {
    return this.restApiService.get('/secure/package/duration-types', 'page-center');
  }

  getVehicleTypeByServiceId(serviceId?, eventId?): Observable<any> {
    return this.restApiService.get('/secure/vehicle-types?serviceTypeIds=' + serviceId + `&eventId=${eventId ? eventId : ''}`, 'page-center');

  }
  getVehicleTypeByServiceIdV1(serviceId?, eventId?): Observable<any> {
    return this.restApiService.get('/secure/v1/vehicle-types?serviceTypeIds=' + serviceId + '&eventId=' + (eventId ? eventId : ''), 'page-center');

  }

  getSupportData(): Observable<any> {
    return this.restApiService.get('/tenants/contact-support', 'page-center');
  }

  getVehiclesByCompanyAndVehicleType(vehicleTypeId, companyId?: any, serviceCities?, serviceId?, eventId?): Observable<any> {
    if (companyId !== null && companyId !== undefined) {
      return this.restApiService.get('/secure/vehicles/data/search?vehicleTypeIds=' + vehicleTypeId
        + '&companyId=' + companyId, 'page-center');
    } else {
      return this.restApiService.get('/secure/vehicles/data/search?vehicleTypeIds=' + vehicleTypeId
        + '&companyId=' + '&serviceAreaIds=' + serviceCities + '&serviceTypeIds=' + serviceId + '&eventId=' + (eventId ? eventId : ''), 'page-center');
    }
  }

  getVehicleDocumentType(): Observable<any> {
    return this.restApiService.get('/secure/vehicle-document-types', 'page-center');
  }

  getCountries(): Observable<any> {
    return this.restApiService.get('/secure/countries', 'page-center');
  }

  getState(id): Observable<any> {
    return this.restApiService.get(`/secure/countries/${id}/states`, 'page-center');
  }
  getCitybyCountries(code): Observable<any> {
    return this.restApiService.get('/secure/countries/' + code + '/citiesbycountry', 'page-center');
  }

  getCitybyState(code): Observable<any> {
    return this.restApiService.get('/secure/countries/' + code + '/citiesbystate', 'page-center');
  }

  getCitybyZipCode(zipCode, countryCode?: any): Observable<any> {
    return this.restApiService.get('/secure/countries-city?zipCode=' + zipCode + '&countryCode=' + countryCode, 'page-center');
  }

  getDispatcher(data, code): Observable<any> {
    return this.restApiService.get(`/secure/dispatchers/data/search?searchText=${data}&roleCode=${code}`, 'page-center');
  }

  getPackageData(packageId): Observable<any> {
    return this.restApiService.get('/secure/package/' + packageId, 'page-center');
  }

  getVehiclePackageData(packageId): Observable<any> {
    return this.restApiService.get('/secure/vehicle-types/default-package/' + packageId, 'page-center');
  }

  updatePackage(packageId, data): Observable<any> {
    return this.restApiService.put('/secure/vehicle-types/default-package/' + packageId, data, 'page-center');
  }

  commentReply(data, id): Observable<any> {
    return this.restApiService.post(`/secure/booking/trip/${id}/comment-reply`, data, 'page-center');
  }

  searchPassengers(url: string): Observable<any> {
    return this.restApiService.get(url, 'page-center');
  }

  readNotifications(notificationId, readStatus): Observable<any> {
    return this.restApiService.put(`/secure/notification/${notificationId}/status`, readStatus, 'page-center');
  }

  addPackage(data): Observable<any> {
    return this.restApiService.post(`/secure/vehicle-types/default-package`, data, 'page-center');
  }

  getLabel(string) {
    let select;
    this.translateService.get(string).subscribe(translatedValue => {
      select = translatedValue;
    });
    return select;
  }

  getSingleOptionFilterState(options: any[] = [], selectedValue?: any, requireDefaultOption: boolean = true) {
    return {
      showFilter: true,
      selectedValue: selectedValue
    };
  }

  getTiming(eventId?) {
    return this.restApiService.get(`/secure/settings/timeouts?eventId=${eventId}`, 'page-center');
  }

  packageBind(serviceType, passengerId?, vehicleTypeId?): Observable<any> {
    if (vehicleTypeId !== null && vehicleTypeId !== undefined) {
      const url = '/secure/packages/allpackages/'
        + this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_AREA_ID) + '/' +
        serviceType + '?vehicleTypeId=' + vehicleTypeId + '&passengerId=' + passengerId;
      return this.restApiService.get(url);
    } else {
      const url = '/secure/packages/allpackages/'
        + this.storageService.getItemFromSessionStorage(AppSettings.SERVICE_AREA_ID) + '/' + serviceType;
      return this.restApiService.get(url);
    }
  }

  getPricingDetails(data) {
    return this.restApiService.get('/secure/packages/' + data, 'page-center');
  }


  specialRequestApproveOrReject(tourId, data) {
    return this.restApiService.put(`/secure/special-request/approve-reject/${tourId}`, data, 'page-center');
  }

  addPricingPackages(data, id?: null) {
    if (id !== undefined && id !== null && id !== '') {
      return this.restApiService.put('/secure/packages/' + id, data, 'page-center');
    } else {
      return this.restApiService.post('/secure/packages', data, 'page-center');
    }
  }
  addSupportManagementForm(data) {

    return this.restApiService.post(`/secure/support-management/support-details`, data, 'page-center');

  }
  searchDriver(url: string): Observable<any> {
    return this.restApiService.get(url);
  }

  addUpdateBooking(data, serviceType, id?): Observable<any> {
    return this.restApiService.post(`/secure/booking/${serviceType}/taxi`, data, 'page-center');
  }

  assignDriver(bookingId, data): Observable<any> {
    return this.restApiService.put('/secure/booking/' + bookingId + '/assign-driver', data);
  }

  resendCode(bookingId, passengerId): Observable<any> {
    return this.restApiService.put('/secure/booking/' + bookingId + '/verification-code');
  }

  cancelBooking(id, data): Observable<any> {
    return this.restApiService.put('/secure/booking/' + id + '/cancel', data);
  }

  getBookingActualRoot(id): Observable<any> {
    return this.restApiService.get(`/secure/tour/actual-path/${id}`);
  }

  bookingDetails(id): Observable<any> {
    return this.restApiService.get('/secure/booking/' + id);
  }

  showBookingsToCancel(tourId, eventId?): Observable<any> {
    return this.restApiService.get(`/secure/tour/associate-bookings/${tourId}?${eventId}`)
  }

  startTrip(data, tripid): Observable<any> {
    return this.restApiService.put('/secure/booking/trip/' + tripid + '/start-trip', data);
  }

  securityCheck(data, tripid): Observable<any> {
    return this.restApiService.post('/secure/bookings/' + tripid + '/security-check', data);
  }

  importBulkFile(data): Observable<any> {
    return this.restApiService.post('/secure/file/import-file', data);
  }

  checkBulkIportStatus(eventid, screenCode?): Observable<any> {
    return this.restApiService.get(`/secure/file-import/inprogress-jobs/${eventid}?screenCode=${screenCode}`, 'page-center');
  }

  endTrip(data, tripid): Observable<any> {
    return this.restApiService.put('/secure/booking/trip/' + tripid + '/end-trip', data);
  }

  extendPackage(tripid): Observable<any> {
    return this.restApiService.put('/secure/bookings/' + tripid + '/extend-package');
  }

  getDriverCurrentLocation(driverId): Observable<any> {
    return this.restApiService.get('/secure/drivers/' + driverId + '/location', 'page-center');
  }

  hasAccessPresent(accessCode) {
    const menuList = this.getSelectedMenuAccessesList();
    const hasAccess = menuList.find((elm) => {
      return elm.accessCode === accessCode;
    });

    if (hasAccess !== undefined && hasAccess !== null) {
      return true;
    }
    return false;
  }

  /**
   *
   * @param accessCode : accessCode to check access
   * @param accessGroupCode : accessGroupCode to find access
   */

  hasLogicalAccessPresent(accessCode, accessGroupCode) {
    const menuList = this.checkLogicalGroupAccess(accessGroupCode);
    const hasAccess = menuList.find((elm) => {
      return elm.accessCode === accessCode;
    });

    if (hasAccess !== undefined && hasAccess !== null) {
      return true;
    }
    return false;
  }

  getSubmenuListByMenuName(menuName) {
    let menuItems: any = [];
    menuItems = this.storageService.getItemFromSessionStorage(AppSettings.ACCESS_MENU);
    for (let menuIndex = 0; menuIndex < menuItems.length; menuIndex++) {
      const menu = menuItems[menuIndex];
      if (menu.name === menuName) {
        return menu.subMenuList;
      }
    }
    return [];
  }

  getSelectedMenuAccessesList(returnObj?) {
    const location = window.location.href;
    const urlArray = location.split('#');
    const displayUrls = urlArray[urlArray.length - 1];
    const displayUrl = displayUrls.split('?')[0];
    let menuItems: any = [];
    menuItems = this.storageService.getItemFromSessionStorage(AppSettings.ACCESS_MENU);
    for (let menuIndex = 0; menuIndex < menuItems.length; menuIndex++) {
      const menu = menuItems[menuIndex];
      if (displayUrl.indexOf(menu.displayUrl) >= 0 && menu.displayUrl !== '') {
        if (returnObj) {
          return menu;
        }
        return menu.accesses ? menu.accesses : [];
      } else {
        if (menu.subMenuList && menu.subMenuList.length) {
          const subMenuAccess = this.checkSubmenus(menu.subMenuList, displayUrl, returnObj);
          if (subMenuAccess !== undefined && subMenuAccess !== null) {
            return subMenuAccess;
          }
        }
      }
    }
    return [];
  }

  checkSubmenus(subMenuList, menuName, returnObj?) {
    if (subMenuList !== undefined && subMenuList !== null) {
      for (let menuIndex = 0; menuIndex < subMenuList.length; menuIndex++) {
        const menu = subMenuList[menuIndex];
        if (menuName.indexOf(menu.displayUrl) >= 0 && menu.displayUrl !== '') {
          if (returnObj) {
            return menu;
          }
          return menu.accesses ? menu.accesses : [];
        } else {
          if (menu.subMenuList && menu.subMenuList.length) {
            const subMenuAccess = this.checkSubmenus(menu.subMenuList, menuName, returnObj);
            if (subMenuAccess !== undefined && subMenuAccess !== null) {
              return subMenuAccess;
            }
          }
        }
      }
      return null;
    }
  }

  checkLogicalGroupAccess(accessGroupCode) {
    this.accesses = this.storageService.getItemFromSessionStorage(AppSettings.ACCESS_MENU);
    if (this.accesses.length) {
      for (let i = 0; i < this.accesses.length; i++) {
        if (this.compareAccressGroupCode(this.accesses[i].accessGroupCode, accessGroupCode)) {
          return this.accesses[i].accesses ? this.accesses[i].accesses : [];
        } else {
          if (this.accesses[i].subMenuList.length) {
            for (let j = 0; j < this.accesses[i].subMenuList.length; j++) {
              if (this.compareAccressGroupCode(this.accesses[i].subMenuList[j].accessGroupCode, accessGroupCode)) {
                return this.accesses[i].subMenuList[j].accesses ? this.accesses[i].subMenuList[j].accesses : [];
              }
            }
          }
        }
      }
    }
    return [];
  }

  compareAccressGroupCode(groupCode, accessGroupCode) {
    return groupCode ? groupCode.toLowerCase().indexOf(accessGroupCode.toLowerCase()) >= 0 : false;
  }

  compareUrl(srcUrl, routeUrl) {
    return srcUrl ? srcUrl.toLowerCase().indexOf(routeUrl.toLowerCase()) >= 0 : false;
  }

  getCities(eventId?): Observable<any> {
    return this.restApiService.get(`/secure/service-area/cities?eventId=${eventId ? eventId : ''}`);
  }

  getCitiesForBooking(serviceTypeId?, vehicleTypeId?, sourceCityId?, eventId?): Observable<any> {
    return this.restApiService.get('/secure/service-area/cities?serviceTypeId=' +
      serviceTypeId + '&vehicleTypeId=' + vehicleTypeId + '&sourceCityId=' + sourceCityId + '&eventId=' + (eventId ? eventId : ''));
  }

  getServiceAreaByCompanyId(companyId, eventId?): Observable<any> {
    return this.restApiService.get('/secure/companies-service-area/list/' + companyId + '?eventId=' + (eventId ? eventId : ''), 'page-center');
  }

  getServiceAreaByUserId(userId): Observable<any> {
    return this.restApiService.get('/secure/service-area/' + userId + '/city', 'page-center');
  }

  getEventList(transportModes?: boolean): Observable<any> {
    const queryParam = transportModes ? '&transportModes=true' : '';
    return this.restApiService.get(`/secure/events/list?activated=true&searchText=${queryParam}`, 'page-center');
  }

  fetchTourBooking(tourId): Observable<any> {
    return this.restApiService.get('/secure/tour/' + tourId);
  }
  getDropDownData(list, key, value) {
    return (list !== null && list !== undefined) ?
      list.map(item => ({ label: item[key], value: item[value] })) : [];
  }

  getDropDownDataForRaisedByUsers(list, key, value, extraKey) {
    return (list !== null && list !== undefined) ?
    list.map(item => ({ label: item[key], value: item[value], phoneNum: item[extraKey] })) : [];
  }

  getUsers(roleId, activated): Observable<any> {
    return this.restApiService.get(`/secure/users-list?roleId=${roleId}&activated=${activated}`, 'page-center');
  }

  getDocumentDownload(documentId: string, eventId?) {
    return this.restApiService.image(`${AppSettings.BASE_URL}/${AppSettings.TENANT}/file/${documentId}?eventId=${eventId ? eventId : ''}`, documentId);
  }

  getDrivers(vehicleTypeId, tourId?, search?, shiftStatus?, selectedLocation?, requestedSortKey?): Observable<any> {
    const searchData = search ? search : '';
    const shiftGroup = shiftStatus ? shiftStatus : '';
    return this.restApiService.get(`/secure/drivers/assign-trip/list/` + vehicleTypeId + '?tourId=' +
      tourId + '&searchText=' + searchData + '&shiftStatus=' + shiftStatus +
      '&parkingLocationId=' + selectedLocation + '&limit=10&offset=0&listSortKey=' + requestedSortKey + '&listSortBy=desc', 'page-center');
  }

  getDriversWithoutlimit(vehicleTypeId, tourId?, search?, shiftStatus?, selectedLocation?, requestedSortKey?,
    selectedQueueLocation?, selecteDriverType?): Observable<any> {
    const searchData = search ? search : '';
    const shiftGroup = shiftStatus ? shiftStatus : '';
    return this.restApiService.get(`/secure/drivers/assign-trip/list/` + vehicleTypeId + '?tourId=' +
      tourId + '&searchText=' + searchData + '&shiftStatus=' + shiftStatus +
      '&parkingLocationId=' + selectedLocation + '&queueLocationId=' + selectedQueueLocation + '&selectDriverFrom=' + selecteDriverType +
      '&limit=99999&offset=0&listSortKey=' + requestedSortKey + '&listSortBy=desc', 'page-center');
  }

  getShiftGroupList(eventId?, serviceAreaId?): Observable<any> {
    return this.restApiService.get(`/secure/shift-management/shifts?projection=non-grid&eventId=${eventId ? eventId : ''}&serviceAreaId=${serviceAreaId ? serviceAreaId : ''}`, 'page-center');
  }

  driverAssigned(data): Observable<any> {
    return this.restApiService.put('/secure/tour/assign-driver/bycode', data, 'page-center');
  }

  driverOntheWay(tourId, data): Observable<any> {
    return this.restApiService.put('/secure/tour/driver/ontheway/' + tourId, data, 'page-center');
  }

  updateLuggage(tourId, actionType) {
    return this.restApiService.put(`/secure/luggage-tour/approve-reject/${tourId}/${actionType}`, 'page-center');
  }

  driverArrived(tripId, data): Observable<any> {
    return this.restApiService.put('/secure/booking/' + tripId + '/arrived', data, 'page-center');
  }

  OnTrip(tripId, data): Observable<any> {
    return this.restApiService.put('/secure/booking/trip/' + tripId + '/start-trip', data, 'page-center');
  }

  dropTrip(data): Observable<any> {
    return this.restApiService.post('/secure/tour/dropV2', data, 'page-center');
  }

  acknowledgeTrip(tourId, data): Observable<any> {
    return this.restApiService.put('/secure/tour/' + tourId + '/acknowledge', data, 'page-center');
  }

  bookRideNowAndRideLater(servicetypeid, data): Observable<any> {
    return this.restApiService.post(`/secure/booking/manual/${servicetypeid}`, data, 'page-center');
  }

  getSelectedEvent(): any {
    return this.storageService.getItemFromSessionStorage('selectedEvent');
  }

  getSelectedEventId(): string | null {
    const selectedEvent = this.getSelectedEvent();
    if (selectedEvent?.id) {
      return selectedEvent.id;
    }
    const storedEventId = this.storageService.getItemFromSessionStorage('storedEventId');
    if (storedEventId) {
      return String(storedEventId);
    }
    return this.changedEventId || null;
  }

  getEventTimezone(): string {
    const selectedEvent = this.getSelectedEvent();
    if (selectedEvent?.timezone) {
      return selectedEvent.timezone;
    }
    const storedTimezone = this.storageService.getItemFromSessionStorage('storedTimezone');
    if (storedTimezone) {
      return String(storedTimezone);
    }
    return this.getTenantConfigValue(AppSettings.DEFAULT_TIMEZONE) || this.DEFAULT_TIMEZONE;
  }

  getEventDateFormat(): string {
    const selectedEvent = this.getSelectedEvent();
    return this.resolveFormatValue(
      selectedEvent?.dateFormat,
      AppSettings.DATE_FORMAT,
      this.DEFAULT_DATE_FORMAT
    );
  }

  getEventTimeFormat(): string {
    const selectedEvent = this.getSelectedEvent();
    return this.resolveFormatValue(
      selectedEvent?.timeFormat,
      this.TENANT_TIME_FORMAT_KEY,
      this.DEFAULT_TIME_FORMAT
    );
  }

  getEventDistanceUnit(): string {
    const selectedEvent = this.getSelectedEvent();
    return this.resolveFormatValue(
      selectedEvent?.distanceUnit,
      AppSettings.DISTANCE_UNIT,
      this.DEFAULT_DISTANCE_UNIT
    );
  }

  getEventCountryCode(): string {
    return this.getEventDefaultCountryCode();
  }

  /** Selected event defaultCountryCode; falls back to tenant numCountryCode, then app default. */
  getEventDefaultCountryCode(): string {
    const selectedEvent = this.getSelectedEvent();
    const defaultCountryCode = this.normalizeCountryCode(selectedEvent?.defaultCountryCode);
    if (defaultCountryCode) {
      return defaultCountryCode;
    }

    const tenantInfo: any = this.storageService.getItemFromSessionStorage(AppSettings.TENANT_INFO);
    const tenantCountryCode = this.normalizeCountryCode(tenantInfo?.numCountryCode);
    if (tenantCountryCode) {
      return tenantCountryCode;
    }
    return AppSettings.DEFAULT_COUNTRY_CODE;
  }

  getEventDateFormatMoment(): string {
    return this.toMomentDateFormat(this.getEventDateFormat());
  }

  getEventTimeFormatMoment(): string {
    return this.toMomentTimeFormat(this.getEventTimeFormat());
  }

  getPrimeNgDateFormat(apiFormat?: string): string {
    const format = apiFormat != null && String(apiFormat).trim() !== ''
      ? String(apiFormat).trim()
      : this.getEventDateFormat();
    return this.toPrimeNgDateFormat(format);
  }

  getPrimeNgTimeFormat(): string {
    return this.toPrimeNgTimeFormat(this.getEventTimeFormat());
  }

  getPrimeNgHourFormat(): '12' | '24' {
    const timeFormat = this.getEventTimeFormat();
    return /a/i.test(timeFormat) || /KK/i.test(timeFormat) || /\bhh\b/.test(timeFormat) ? '12' : '24';
  }

  getEventFormatContext(): EventFormatContext {
    const dateFormat = this.getEventDateFormat();
    const timeFormat = this.getEventTimeFormat();
    return {
      eventId: this.getSelectedEventId(),
      timezone: this.getEventTimezone(),
      dateFormat,
      timeFormat,
      distanceUnit: this.getEventDistanceUnit(),
      momentDateFormat: this.toMomentDateFormat(dateFormat),
      momentTimeFormat: this.toMomentTimeFormat(timeFormat),
      primeNgDateFormat: this.toPrimeNgDateFormat(dateFormat),
      primeNgTimeFormat: this.toPrimeNgTimeFormat(timeFormat),
      hourFormat: this.getPrimeNgHourFormat(),
      timeShowSeconds:timeFormat.includes('ss') ? true : false,
      defaultCountryCode: this.getEventDefaultCountryCode(),
    };
  }

  formatEventDate(value: Date | string | number | null | undefined, includeTime = false): string {
    if (value == null || value === '') {
      return '';
    }
    const ctx = this.getEventFormatContext();
    const format = includeTime ? `${ctx.momentDateFormat} ${ctx.momentTimeFormat}` : ctx.momentDateFormat;
    const parsed = moment.tz(value, ctx.timezone);
    return parsed.isValid() ? parsed.format(format) : '';
  }

  formatEventDateTime(value: Date | string | number | null | undefined): string {
    return this.formatEventDate(value, true);
  }

  /**
   * Date-only for a specific Event (multi-event grids): uses that Event's Short Date Format and
   * IANA timezone, not the Global Event Selector. Falls back to tenant format / timezone.
   */
  formatDateForEvent(epochMillis: number | string | null | undefined, eventDateFormat?: string, eventTimezone?: string): string {
    const millis = Number(epochMillis);
    if (epochMillis == null || epochMillis === '' || !Number.isFinite(millis) || millis <= 0) {
      return '';
    }
    const dateFormat = this.resolveFormatValue(eventDateFormat, AppSettings.DATE_FORMAT, this.DEFAULT_DATE_FORMAT);
    const timezone = eventTimezone && moment.tz.zone(eventTimezone)
      ? eventTimezone
      : (this.getTenantConfigValue(AppSettings.DEFAULT_TIMEZONE) || this.DEFAULT_TIMEZONE);
    const parsed = moment.tz(millis, timezone);
    return parsed.isValid() ? parsed.format(this.toMomentDateFormat(dateFormat)) : '';
  }

  /** Time-of-day counterpart of {@link formatDateForEvent}: epoch rendered in the given event's time format and zone. */
  formatTimeForEvent(epochMillis: number | string | null | undefined, eventTimeFormat?: string, eventTimezone?: string): string {
    const millis = Number(epochMillis);
    if (epochMillis == null || epochMillis === '' || !Number.isFinite(millis) || millis <= 0) {
      return '';
    }
    const timeFormat = this.resolveFormatValue(eventTimeFormat, this.TENANT_TIME_FORMAT_KEY, this.DEFAULT_TIME_FORMAT);
    const timezone = eventTimezone && moment.tz.zone(eventTimezone)
      ? eventTimezone
      : (this.getTenantConfigValue(AppSettings.DEFAULT_TIMEZONE) || this.DEFAULT_TIMEZONE);
    const parsed = moment.tz(millis, timezone);
    return parsed.isValid() ? parsed.format(this.toMomentTimeFormat(timeFormat)) : '';
  }

  /** Format calendar start date as MM/DD/YYYY HH:mm (e.g. 08/18/2026 00:00) for API payload. */
  toCalendarStartDateStr(value: Date | string | number | null | undefined): string {
    return this.toCalendarDateStrWithBoundary(value, 'start');
  }

  /** Format calendar end/expiry date as MM/DD/YYYY HH:mm (e.g. 08/18/2026 23:59) for API payload. */
  toCalendarEndDateStr(value: Date | string | number | null | undefined): string {
    return this.toCalendarDateStrWithBoundary(value, 'end');
  }

  /**
   * Parse fixed API wire datetime "MM/DD/YYYY HH:mm" (e.g. "08/01/2027 08:01").
   * Use on edit load before event-format parsing — API always sends US wire format;
   * p-calendar then displays the returned Date using the selected event date/time format.
   */
  parseApiDateTimeStr(dateStr: string | null | undefined): Date | null {
    if (dateStr == null || String(dateStr).trim() === '') {
      return null;
    }
    const raw = String(dateStr).trim();
    const apiFormats = [
      'MM/DD/YYYY HH:mm:ss',
      'MM/DD/YYYY HH:mm',
      'MM/dd/yyyy HH:mm:ss',
      'MM/dd/yyyy HH:mm',
      'MM/DD/YYYY hh:mm:ss A',
      'MM/DD/YYYY hh:mm:ss a',
      'MM/DD/YYYY hh:mm A',
      'MM/DD/YYYY hh:mm a',
      'MM/dd/yyyy hh:mm:ss A',
      'MM/dd/yyyy hh:mm:ss a',
      'MM/dd/yyyy hh:mm A',
      'MM/dd/yyyy hh:mm a',
    ];
    const parsed = moment(raw, apiFormats, true);
    return parsed.isValid() ? parsed.toDate() : null;
  }

  /**
   * Extract date-only Date from API wire datetime "MM/DD/YYYY HH:mm"
   * (e.g. "04/03/2026 10:00" → Date at midnight for date calendar).
   */
  extractApiDateFromDateTimeStr(dateTimeStr: string | null | undefined): Date | null {
    const parsed = this.parseApiDateTimeStr(dateTimeStr);
    if (!parsed) {
      return null;
    }
    const dateOnly = new Date(parsed);
    dateOnly.setHours(0, 0, 0, 0);
    return dateOnly;
  }

  /**
   * Extract time-only Date from API wire datetime "MM/DD/YYYY HH:mm"
   * (e.g. "04/03/2026 10:00" → Date with hours/minutes for timeOnly calendar).
   */
  extractApiTimeFromDateTimeStr(dateTimeStr: string | null | undefined): Date | null {
    if (dateTimeStr == null || String(dateTimeStr).trim() === '') {
      return null;
    }
    const raw = String(dateTimeStr).trim();
    if (raw.split(/\s+/).length < 2) {
      return null;
    }
    const parsed = this.parseApiDateTimeStr(raw);
    if (!parsed) {
      return null;
    }
    const timeOnly = new Date();
    timeOnly.setHours(parsed.getHours(), parsed.getMinutes(), parsed.getSeconds(), 0);
    return timeOnly;
  }

  /**
   * Combine date + time calendar values into API wire format "MM/DD/YYYY HH:mm"
   * Same approach as Add Location `toBookingDateStr`:
   * date via toCalendarStartDateStr, time via getTimeInHHmm.
   */
  combineToApiDateTimeStr(
    dateValue: Date | string | number | null | undefined,
    timeValue: Date | string | number | null | undefined
  ): string {
    if (dateValue == null || dateValue === '') {
      return '';
    }
    const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
    if (isNaN(date.getTime())) {
      return '';
    }

    const datePart = this.toCalendarStartDateStr(date).split(' ')[0];
    if (!datePart) {
      return '';
    }

    const time = timeValue instanceof Date
      ? timeValue
      : (timeValue != null && timeValue !== '' ? new Date(timeValue) : null);
    const timePart = (time instanceof Date && !isNaN(time.getTime()))
      ? this.getTimeInHHmm(time)
      : '00:00';
    return `${datePart} ${timePart}`;
  }

  /**
   * Format API wire datetime for read-only UI labels: MM/DD/YYYY HH:mm → selected event date format.
   * Uses wall-clock components from the wire string (no event-timezone shift).
   * For form calendars use parseApiDateTimeStr / parseCalendarDateStr + p-calendar dateFormat instead.
   */
  formatApiDateTimeForDisplay(dateStr: string | null | undefined, includeTime = false): string {
    if (dateStr == null || String(dateStr).trim() === '') {
      return '';
    }
    const raw = String(dateStr).trim();
    const apiFormats = [
      'MM/DD/YYYY HH:mm:ss',
      'MM/DD/YYYY HH:mm',
      'MM/dd/yyyy HH:mm:ss',
      'MM/dd/yyyy HH:mm',
      'MM/DD/YYYY hh:mm:ss A',
      'MM/DD/YYYY hh:mm:ss a',
      'MM/DD/YYYY hh:mm A',
      'MM/DD/YYYY hh:mm a',
      'MM/dd/yyyy hh:mm:ss A',
      'MM/dd/yyyy hh:mm:ss a',
      'MM/dd/yyyy hh:mm A',
      'MM/dd/yyyy hh:mm a',
      'MM/DD/YYYY',
      'MM/dd/yyyy',
      'MMM DD YYYY hh:mm:ss A',
      'MMM DD YYYY hh:mm A',
      'MMM DD YYYY',
      'MMM D YYYY hh:mm:ss A',
      'MMM D YYYY hh:mm A',
      'MMM D YYYY',
    ];
    const parsed = moment(raw, apiFormats, true);
    if (!parsed.isValid()) {
      return raw;
    }
    const ctx = this.getEventFormatContext();
    const format = includeTime ? `${ctx.momentDateFormat} ${ctx.momentTimeFormat}` : ctx.momentDateFormat;
    return parsed.format(format);
  }

  /** Prefer dateStr on edit to avoid timezone shifts from epoch millis. */
  parseCalendarDateStr(dateValue: any, dateStr?: any): Date | null {
    if (dateStr != null && String(dateStr).trim() !== '') {
      const raw = String(dateStr).trim();
      const parsedApi = this.parseApiDateTimeStr(raw);
      if (parsedApi) {
        return parsedApi;
      }
      const ctx = this.getEventFormatContext();
      const formats = [
        `${ctx.momentDateFormat} ${ctx.momentTimeFormat}`,
        ctx.momentDateFormat,
        `MM/DD/YYYY ${ctx.momentTimeFormat}`,
        `MM/dd/yyyy ${ctx.momentTimeFormat}`,
        'MM/DD/YYYY HH:mm:ss',
        'MM/DD/YYYY HH:mm',
        'MM/dd/yyyy HH:mm:ss',
        'MM/dd/yyyy HH:mm',
        'MM/DD/YYYY hh:mm:ss A',
        'MM/DD/YYYY hh:mm:ss a',
        'MM/DD/YYYY hh:mm A',
        'MM/DD/YYYY hh:mm a',
        'MM/dd/yyyy hh:mm:ss A',
        'MM/dd/yyyy hh:mm:ss a',
        'MM/dd/yyyy hh:mm A',
        'MM/dd/yyyy hh:mm a',
        `DD/MM/YYYY ${ctx.momentTimeFormat}`,
        'DD/MM/YYYY HH:mm:ss',
        'DD/MM/YYYY HH:mm',
        'DD/MM/YYYY',
        'D/M/YYYY HH:mm:ss',
        'D/M/YYYY HH:mm',
        'D/M/YYYY',
        'DD/MM/YYYY hh:mm:ss A',
        'DD/MM/YYYY hh:mm A',
        'MMM DD YYYY hh:mm:ss A',
        'MMM DD YYYY hh:mm:ss a',
        'MMM DD YYYY hh:mm A',
        'MMM DD YYYY hh:mm a',
        'MMM D YYYY hh:mm:ss A',
        'MMM D YYYY hh:mm:ss a',
        'MMM D YYYY hh:mm A',
        'MMM D YYYY hh:mm a',
        'MMM DD YYYY HH:mm:ss',
        'MMM DD YYYY HH:mm',
        'MMM D YYYY HH:mm:ss',
        'MMM D YYYY HH:mm',
        'MMM DD YYYY',
        'MMM D YYYY',
      ].filter(Boolean);

      const parsedFromStr = moment(raw, formats, true);
      if (parsedFromStr.isValid()) {
        return parsedFromStr.toDate();
      }

      const datePart = raw.split(/\s+\d{1,2}:\d{2}/)[0].trim(); // drop time part if present
      const parsedDateOnly = moment(
        datePart,
        [
          'MM/DD/YYYY',
          'MM/dd/yyyy',
          'DD/MM/YYYY',
          'D/M/YYYY',
          'MMM DD YYYY',
          'MMM D YYYY',
          ctx.momentDateFormat,
        ].filter(Boolean),
        true
      );
      if (parsedDateOnly.isValid()) {
        return parsedDateOnly.toDate();
      }
    }

    if (dateValue == null || dateValue === '' || dateValue === 0) {
      return null;
    }

    const calendarDate = this.toEventCalendarDate(dateValue);
    if (calendarDate) {
      return calendarDate;
    }

    const fallback = new Date(dateValue);
    return isNaN(fallback.getTime()) ? null : fallback;
  }

  /** Parse time-only string using selected event time format (+ common fallbacks). */
  parseEventTimeOfDay(timeStr: any): Date | null {
    if (timeStr == null || timeStr === '') {
      return null;
    }

    const raw = String(timeStr).trim();
    const ctx = this.getEventFormatContext();
    const formats = [
      ctx.momentTimeFormat,
      'hh:mm:ss A',
      'hh:mm:ss a',
      'hh:mm A',
      'hh:mm a',
      'HH:mm:ss',
      'HH:mm',
      'H:mm:ss',
      'H:mm',
    ].filter(Boolean);

    const parsed = moment(raw, formats, true);
    if (!parsed.isValid()) {
      return null;
    }

    const date = new Date();
    date.setHours(parsed.hours(), parsed.minutes(), parsed.seconds(), 0);
    return date;
  }

  /** Format time-only value using selected event time format. */
  formatEventTimeOfDay(value: Date | string | number | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
      return '';
    }
    return moment(date).format(this.getEventTimeFormatMoment());
  }

  /** Midnight in selected event time format (e.g. 00:00, 00:00:00, 12:00:00 AM). */
  getDefaultEventTimeOfDayStr(): string {
    return moment().startOf('day').format(this.getEventTimeFormatMoment());
  }

  private toCalendarDateStrWithBoundary(
    value: Date | string | number | null | undefined,
    boundary: 'start' | 'end'
  ): string {
    if (value == null || value === '') {
      return '';
    }

    const parsed = value instanceof Date ? value : new Date(value);
    if (isNaN(parsed.getTime())) {
      return '';
    }

    const datePart = moment(parsed).format('MM/DD/YYYY');
    const timePart = boundary === 'start' ? '00:00' : '23:59';
    return `${datePart} ${timePart}`;
  }

  /**
   * Parses an API booking date string of fixed format "MM/DD/YYYY HH:mm",
   * strips the time portion, and reformats the date using the selected event's date format.
   * Safe to call from any component that needs to display bookingStartDateStr / bookingEndDateStr.
   * Also used for driver/passenger/vehicle date-only *Str fields in the same wire format.
   */
  formatBookingDateStr(dateStr: string | null | undefined): string {
    if (dateStr == null || String(dateStr).trim() === '') {
      return '';
    }
    const raw = String(dateStr).trim();
    const datePart = raw.split(/\s+/)[0];
    const mmDdParsed = moment(datePart, ['MM/DD/YYYY', 'MM/dd/yyyy', 'M/D/YYYY', 'M/D/yyyy'], true);
    if (mmDdParsed.isValid()) {
      return mmDdParsed.format(this.getEventFormatContext().momentDateFormat);
    }
    return this.formatApiDateTimeForDisplay(raw, false);
  }

  toEventCalendarDate(value: Date | string | number | null | undefined): Date | null {
    if (value == null || value === '') {
      return null;
    }
    const parsed = moment.tz(value, this.getEventTimezone());
    return parsed.isValid() ? parsed.toDate() : null;
  }

  fromEventCalendarDate(value: Date | null | undefined): number | null {
    if (!value) {
      return null;
    }
    const timezone = this.getEventTimezone();
    const eventDate = moment.tz({
      year: value.getFullYear(),
      month: value.getMonth(),
      day: value.getDate(),
      hour: value.getHours(),
      minute: value.getMinutes(),
      second: value.getSeconds(),
      millisecond: value.getMilliseconds(),
    }, timezone);
    return eventDate.isValid() ? eventDate.valueOf() : null;
  }

  toEventDateStartOfDayMs(value: Date | string | number | null | undefined): number | null {
    if (value == null || value === '') {
      return null;
    }
    const parsed = moment.tz(value, this.getEventTimezone()).startOf('day');
    return parsed.isValid() ? parsed.valueOf() : null;
  }

  toEventDateEndOfDayMs(value: Date | string | number | null | undefined): number | null {
    if (value == null || value === '') {
      return null;
    }
    const parsed = moment.tz(value, this.getEventTimezone()).endOf('day');
    return parsed.isValid() ? parsed.valueOf() : null;
  }

  getDateFormat() {
    let dateFormatRecord = this.getTenantConfigValue(AppSettings.DATE_FORMAT);
    const check = dateFormatRecord.includes('yyyy');
    if (check) {
      dateFormatRecord = dateFormatRecord.replace('yyyy', 'yy');
      dateFormatRecord = dateFormatRecord.replace('MMM', 'M');
    }
    return dateFormatRecord;
  }

  getDateFormatFromTenant() {
    let dateFormatRecord = this.getTenantConfigValue(AppSettings.DATE_FORMAT);
    return dateFormatRecord;
  }

  private normalizeCountryCode(value: any): string {
    if (value == null || value === '') {
      return '';
    }
    return String(value).trim();
  }

  /** Prefer selected-event value; else tenant config; else hard default. */
  private resolveFormatValue(
    rawValue: any,
    tenantConfigKey: string,
    defaultValue: string
  ): string {
    const tenantValue = this.getTenantConfigValue(tenantConfigKey);
    if (rawValue == null || rawValue === '') {
      return tenantValue || defaultValue;
    }

    const normalized = this.normalizeTimeFormatAlias(String(rawValue).trim());
    return normalized || tenantValue || defaultValue;
  }

  /** Normalize legacy KK (12h) aliases to hh used by moment. */
  private normalizeTimeFormatAlias(value: string): string {
    if (!value) {
      return value;
    }
    return value
      .replace(/KK/g, 'hh')
      .replace(/\bkk\b/g, 'hh');
  }

  private toMomentDateFormat(apiFormat: string): string {
    if (!apiFormat) {
      return 'DD MMM YYYY';
    }
    return apiFormat
      .replace(/yyyy/g, 'YYYY')
      .replace(/dd/g, 'DD');
  }

  private toMomentTimeFormat(apiFormat: string): string {
    if (!apiFormat) {
      return AppSettings.DEFAULT_TIME_FORMATE;
    }
    return this.normalizeTimeFormatAlias(apiFormat)
      .replace(/\ba\b/g, 'A');
  }

  private toPrimeNgDateFormat(apiFormat: string): string {
    if (!apiFormat) {
      return AppSettings.ADD_BOOKING_DATE_FORMAT_PRIMENG;
    }
    return apiFormat
      .replace(/MMM/g, '{{MONTH_NAME}}')
      .replace(/yyyy/g, 'yy')
      .replace(/MM/g, 'mm')
      .replace(/{{MONTH_NAME}}/g, 'M');
  }

  private toPrimeNgTimeFormat(apiFormat: string): string {
    if (!apiFormat) {
      return AppSettings.DEFAULT_TIME_FORMATE;
    }
    return this.normalizeTimeFormatAlias(apiFormat)
      .replace(/\ba\b/g, 'A');
  }

  getPrivacyPolicy(languageCode?: string): Observable<any> {
    const resolvedLanguageCode = (languageCode || '').trim().toLowerCase();
    const url = resolvedLanguageCode ? `/tenants/privacy-policy?languageCode=${encodeURIComponent(resolvedLanguageCode)}` : '/tenants/privacy-policy';
    return this.restApiService.getText(url, 'page-center');
  }

  cashCollecte(tripid, data): Observable<any> {
    return this.restApiService.put('/secure/tour/collect-cash/' + tripid, data);
  }


  /*AEL start **/
  getAssignDriverList(): Observable<any> {
    return this.restApiService.get(`/secure/drivers/list/data?limit=500`, 'page-center');
  }

  getPickupDropAddress(searchText?, addressType?, userType?, passengerId?, journeyTypetoSend?, eventId?, serviceAreaId?): Observable<any> {
    return this.restApiService.get(`/secure/location/search-places?searchText=${searchText}` +
      `&addressType=${addressType}&userType=${userType}&passengerId=${passengerId}&journeyType=${journeyTypetoSend}&eventId=${eventId ? eventId : ''}` +
      `&serviceAreaId=${serviceAreaId}`, 'page-center');
  }

  getPickupDropListForShuttle(addressType?, userType?, journeyTypetoSend?, eventId?): Observable<any> {
    return this.restApiService.get(`/secure/location/search-places?searchText=` +
      `&addressType=${addressType}&userType=${userType}&passengerId=&journeyType=${journeyTypetoSend}&eventId=${eventId ? eventId : ''}`, 'page-center');
  }

  getDispatchQueueLocations(projection?: string, locationCategoryId?, tourId?, etaDistance?, eventId?): Observable<any> {
    return this.restApiService.get(`/secure/locations?projection=${projection}&locationCategoryId=${locationCategoryId}` +
      `&tourId=${tourId}&etaDistance=${etaDistance}&eventId=${eventId ? eventId : ''}` +
      `&activated=&searchText=&offset=&limit=&sortColumn=&sortType=`, 'page-center');
  }

  setDispatchLocation(data): Observable<any> {
    return this.restApiService.post('/secure/tour/dispatch-location', data, 'page-center');
  }

  bookingTabCount(eventId?): Observable<any> {
    const storedEventId = this.storageService.getItemFromSessionStorage('storedEventId');
    const resolvedEventId = eventId !== undefined && eventId !== null && eventId !== ''
      ? eventId
      : (this.changedEventId ? this.changedEventId : (storedEventId ? storedEventId : ''));
    return this.restApiService.get(`/secure/current-bookings/tabs-count?eventId=${resolvedEventId}`, 'page-center');
  }

  gerPrivilegeData(id, userid?, fromDate?, toDate?, eventId?): Observable<any> {
    // TN-manage-booking-208-FE: eventId is appended only when given, so existing callers keep their URL.
    const eventParam = eventId ? `&eventId=${eventId}` : '';
    if (fromDate && toDate) {
      return this.restApiService.get(`/secure/privilege-settings/passenger-type-permissions?passengerTypeId=` +
        `${id}&passengerId=${userid}&fromDate=${fromDate}&toDate=${toDate}${eventParam}`, 'page-center');
    } else {
      return this.restApiService.get(`/secure/privilege-settings/passenger-type-permissions?passengerTypeId=` +
        `${id}&passengerId=${userid}${eventParam}`, 'page-center');
    }
  }

  AssigneToAndFromThirdParty(tourId, data,): Observable<any> {
    return this.restApiService.put('/secure/booking/' + tourId + '/assign-third-party', data, 'page-center');
  }

  AssigneToAutobroadcast(tourId, data,): Observable<any> {
    return this.restApiService.put('/secure/tour-autobroadcast/' + tourId + '/status', data, 'page-center');
  }

  // for confirmed by admin
  changeBackToNewRequest(tourId, data): Observable<any> {
    return this.restApiService.put(`/secure/tour-status/random-update/${tourId}`, data, 'page-center');
  }

  // for confirmed by admin
  adminConfirmed(tourId, data): Observable<any> {
    return this.restApiService.put('/secure/booking/' + tourId + '/admin-confirm', data, 'page-center');
  }

  // used for assign driver
  getParkingLocationsList(locationCategoryId?, dispatchZoneId?, eventId?): Observable<any> {
    return this.restApiService.get(`/secure/locations?projection=grid&locationCategoryId=${locationCategoryId}&` +
      `dispatchZoneId=${dispatchZoneId}&isLimit=false&activated=true&eventId=${eventId}`,
      'page-center');
  }

  // used for assign driver Quelocations
  getAllLocations(eventId?): Observable<any> {
    return this.restApiService.get('/secure/locations?projection=non-grid&eventId=' + eventId, 'page-center');
  }

  // for first acknowledge by driver
  driverFirstConfirmed(tourId, data): Observable<any> {
    return this.restApiService.put('/secure/booking/' + tourId + '/driver-confirm', data, 'page-center');
  }

  // used for grid filter
  getPassengerAllocatedLocationData(queueLocaationcatId, eventId?, serviceAreaId = ''): Observable<any> {
    return this.restApiService.get(`/secure/locations?projection=grid&isLimit=false&` +
      `locationCategoryId=${queueLocaationcatId}` + `&eventId=${eventId}` + `&serviceAreaId=${serviceAreaId}`, 'page-center');
  }
  getDropOffLocations(queueLocaationcatId, eventId?,serviceAreaId?): Observable<any> {
    return this.restApiService.get(`/secure/locations?projection=grid&isLimit=false&` +
      `locationCategoryId=${queueLocaationcatId}` + `&eventId=${eventId}` + `&activated=true` + `&serviceAreaId=${serviceAreaId}`, 'page-center');
  }

  // used for get ETA on grid
  getETA(bookingId): Observable<any> {
    return this.restApiService.get(`/secure/tour/eta/${bookingId}`, 'page-center');
  }

  getPassengerType(eventId?): Observable<any> {
    return this.restApiService.get('/secure/privilege-settings/data-grid?offset=0&limit=&eventId=' + (eventId ? eventId : ''), 'page-center');
  }

  getVehiclesToTransfer(locationId = '', vehicleTypeId?, eventID?): Observable<any> {
    return this.restApiService.get(`/secure/drivers/vehicle-transfer/list?locationId=${locationId}&vehicleTypeId=${vehicleTypeId}&eventId=${eventID ? eventID : ''}`, 'page-center');
  }

  convertDistanceMeterToMiles(meters) {
    return (meters * 0.000621371192).toFixed(2);
  }

  convertTimeToMinuts(miliseconds) {
    const minutes = Math.floor(miliseconds / 60000);
    const seconds = ((miliseconds % 60000) / 1000).toFixed(0);
    return minutes + ':' + (+seconds < 10 ? '0' : '') + seconds + ' ' + this.getLabel('Mins');
  }

  getDriverPosition(tripId: any): Observable<any> {
    return this.restApiService.get(`/secure/tour-driver/current-location/${tripId}`, 'page-center');
  }

  checkIsEditable(bookingStatus) {
    return (AppSettings.DRIVER_ASSIGN_CONDITIONS.indexOf(bookingStatus) > -1);
  }

  allowEditForAdminConfirmed(bookingStatus) {
    return (AppSettings.DRIVER_ASSIGN_CONDITIONS_edit.indexOf(bookingStatus) > -1);
  }

  getsummaryReportDetails(url): Observable<any> {
    return this.restApiService.get(url, 'page-center');
  }

  sendResetPasswordLink(data): Observable<any> {
    return this.restApiService.put(`/secure/users/reset-password/send-token`, data, 'page-center');
  }

  sendResetPasswordLinkforShuttle(data): Observable<any> {
    return this.restApiService.put(`/secure/users/reset-password/send-token`, data, 'page-center');
  }

  getBusOperator(eventId?): Observable<any> {
    return this.restApiService.get(`/secure/bus-operators?eventId=${(eventId ? eventId : '')}`, 'page-center');
  }

  getLayoutType(): Observable<any> {
    return this.restApiService.get('/secure/bus-floor-layouts', 'page-center');
  }

  getBusDestinationPoints(eventId?): Observable<any> {
    return this.restApiService.get(`/secure/bus-destinations?eventId=${(eventId ? eventId : '')}`, 'page-center');
  }

  getScheduleList(eventId?): Observable<any> {
    return this.restApiService.get(`/secure/bus-schedules?eventId=${(eventId ? eventId : '')}`, 'page-center');
  }

  encrypt(value: string): string {
    let g = this.secretKey.trim();
    if (value) {
      return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
    }
  }

  decrypt(textToDecrypt: string) {
    if (textToDecrypt) {
      return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(
        CryptoJS.enc.Utf8
      );
    }
  }

  getMergedBookingCodesTooltip(params) {
    if (!params.mergedRide || !params.mergeBookingList) {
      return '';
    }
    let bookingCodes = [];
    if (typeof params.mergeBookingList === 'string') {
      bookingCodes = params.mergeBookingList.split(',').map((code: string) => code.trim()).filter((code: string) => code);
    } else if (Array.isArray(params.mergeBookingList)) {
      bookingCodes = params.mergeBookingList;
    }
    if (bookingCodes.length > 0) {
      return bookingCodes.join('\n');
    }
    return '';
  }

  getFlightTrainIconHtml(params): string {
    const bookingType = params.airportBookingType || params.airportBookingTypes;
    const airportBookingTypes = AppSettings.AIRPORT_BOOKING_TYPES || [];
    const isTrainType = [airportBookingTypes[2], airportBookingTypes[3]].includes(bookingType);
    const isAirportType = [airportBookingTypes[0], airportBookingTypes[1]].includes(bookingType);
    const showIcon = params.flightNumber || isAirportType || isTrainType;
    if (!showIcon) {
      return '';
    }
    const icon = isTrainType ? '/assets/images/temp/train-icon.svg' : '/assets/images/temp/flight-icon.svg';
    const typeLabel = isTrainType ? 'Train' : 'Flight';
    const title = params.flightNumber
      ? (typeLabel + ' Number: ' + params.flightNumber + ' \nArrival Time: ' + (params.flightArrivalTimeStr || 'N/A'))
      : ('No ' + typeLabel.toLowerCase() + ' details are available');
    return '<img class="flight-icon" width="16px" height="16px" src="' + icon +
      '" title="' + title + '" style="cursor: pointer; margin-left: 0.5rem;" />';
  }

  getBookingTourCode(params) {
    const eDiv = document.createElement('div');
    eDiv.className = "bookingCode"
    const mergedBookingCodesTooltip = this.getMergedBookingCodesTooltip(params);
    const PreparedData =
      `        <div class="bookingCode-container flex align-items-center">
          <div class="bookingCode" title="${params.tripId}">` + params.tripId + `</div>
          ${this.getFlightTrainIconHtml(params)}
        </div>
      <div class="booking-grid-table rideLaterNowStyle mt-2 flex justify-content-start align-items-center">
        <img class="rideLaterNowIcon" width="16px" height="11px" src="${params.appBooking ? '/assets/images/temp/phone.svg' : '/assets/images/temp/monitor.svg'}"/>
        <span class="ml-2 fontSize12">${params.onDemand ? 'Ride Now' : 'Ride Later'}</span>
      </div>
      ${params.mergedRide ? `<div class="booking-grid-table mergeBookingStyle mt-2 flex justify-content-start align-items-center">
        <span title="${mergedBookingCodesTooltip || ''}" style="cursor: pointer;">Shared Ride <i class="fa fa-angle-right" style="color: #05b061; font-weight: 900;"></i></span>
      </div>` : ''}
      `;
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getBookingCode(params) {
    const eDiv = document.createElement('div');
    eDiv.className = "bookingCode"
    const mergedBookingCodesTooltip = this.getMergedBookingCodesTooltip(params);
    const PreparedData =
      `        <div class="bookingCode-container flex align-items-center">
          <div class="bookingCode" title="${params.bookingCode}">` + params.bookingCode + `</div>
          ${this.getFlightTrainIconHtml(params)}
        </div>
      <div class="booking-grid-table rideLaterNowStyle mt-2 flex justify-content-start align-items-center">
        <img class="rideLaterNowIcon" width="16px" height="11px" src="${params.appBooking ? '/assets/images/temp/phone.svg' : '/assets/images/temp/monitor.svg'}"/>
        <span class="ml-2 fontSize12">${params.onDemand ? 'Ride Now' : 'Ride Later'}</span>
      </div>
      ${params.mergedRide ? `<div class="booking-grid-table mergeBookingStyle mt-2 flex justify-content-start align-items-center">
        <span title="${mergedBookingCodesTooltip || ''}" style="cursor: pointer;">Shared Ride <i class="fa fa-angle-right" style="color: #05b061; font-weight: 900;"></i></span>
      </div>` : ''}
      `;
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getPickDropLocation(params) {
    const eDiv = document.createElement('div');
    const addressInstructions = this.prepareNote(params);
    const pickupLocationName = this.escapeHtml(params?.pickupAddress ?? '');
    const dropLocationName = this.escapeHtml(params?.dropAddress ?? '');
    const PreparedData = `
    <div style="margin-top: -13px;margin-bottom: -4px;">
    <div class="col-12 booking-grid-table booking-details pad-top" title="">
    <div class="col-12 grid mt-1">
      <div class="col-1 md:col-1 lg:col-2 passenger-name address-container">
        <div class="start-point-new"><img src="/assets/images/temp/pickup.png"></div>
        <div class="divider"></div>
        <div class="end-point-new"><img src="/assets/images/temp/drop-off.png"></div>
      </div>
      <div class="col-10 md:col-10 lg:col-10 passenger-name">
        <div class="passenger-name passengerName" title="${pickupLocationName}">` + pickupLocationName + `</div>
        <div class="pickup-date drop-adr opa-9 passengerName" title="${dropLocationName}">` + dropLocationName + `</div>
      </div>
    </div>` + ((params.tripNote || params.passengerNote || params.passengerStayAddressNote) ? `
    <div class="col-12" style="margin-top: -5px;">
      <span class="address-instrn" title="${addressInstructions}"><img src="/assets/images/temp/info-icon.svg"></span>
    </div>` : '') +
      `</div>
     </div>`;
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  private escapeHtml(value: any): string {
    const str = value === null || value === undefined ? '' : String(value);
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  getSourceDestinationLocation(params) {
    const eDiv = document.createElement('div');
    const addressInstructions = this.prepareNote(params);
    const PreparedData = `
    <div style="margin-top: -13px;margin-bottom: -4px;">
    <div class="col-12 booking-grid-table booking-details pad-top" title="">
    <div class="col-12 grid mt-1">
      <div class="col-1 md:col-1 lg:col-2 passenger-name address-container">
        <div class="start-point-new"><img src="/assets/images/temp/pickup.png"></div>
        <div class="divider"></div>
        <div class="end-point-new"><img src="/assets/images/temp/drop-off.png"></div>
      </div>
      <div class="col-10 md:col-10 lg:col-10 passenger-name">
        <div class="passenger-name" title="${params.source}">` + params.source + `</div>
        <div class="pickup-date drop-adr opa-9" title="${params.destination}">` + params.destination + `</div>
      </div>
    </div>` + ((params.tripNote || params.passengerNote || params.passengerStayAddressNote) ? `
    <div clas="col-12" style="margin-top: -5px;">
      <span class="address-instrn" title="${addressInstructions}"><img src="/assets/images/temp/info-icon.svg"></span>
    </div>` : '') +
      `</div></div>`;
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  prepareNote(params) {
    let totalNote = '';
    if (params.tripNote) {
      totalNote += `Booking note: ${params.tripNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    if (params.passengerNote) {
      totalNote += `Passenger note: ${params.passengerNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    if (params.passengerStayAddressNote) {
      totalNote += `Address note: ${params.passengerStayAddressNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    return totalNote;
  }

  getFromAndToDate(params) {
    const eDiv = document.createElement('div');
    eDiv.innerHTML += `<div title = "${params.applicableFromDateTimeStr}">${params.applicableFromDateTimeStr}</div>`;
    eDiv.innerHTML += `<div class="mt-2" title = "${params.applicableToDateTimeStr}">${params.applicableToDateTimeStr}</div>`;
    return eDiv;
  }

  getActiveDays(params) {
    const eDiv = document.createElement('div');
    let returnString = '';
    returnString += params.monApplicable ? 'M ' : '- ';
    returnString += params.tueApplicable ? 'T ' : '- ';
    returnString += params.wedApplicable ? 'W ' : '- ';
    returnString += params.thuApplicable ? 'T ' : '- ';
    returnString += params.friApplicable ? 'F ' : '- ';
    returnString += params.satApplicable ? 'S ' : '- ';
    returnString += params.sunApplicable ? 'S ' : '- ';
    eDiv.innerHTML += `<div title = "${returnString}">${returnString}</div>`;
    return eDiv;
  }

  getActiveDaysStr(params) {
    let returnString = '';
    let activeDays = [];
    params.sunApplicable ? activeDays.push('Sun') : '';
    params.monApplicable ? activeDays.push('Mon') : '';
    params.tueApplicable ? activeDays.push('Tue') : '';
    params.wedApplicable ? activeDays.push('Wed') : '';
    params.thuApplicable ? activeDays.push('Thu') : '';
    params.friApplicable ? activeDays.push('Fri') : '';
    params.satApplicable ? activeDays.push('Sat') : '';

    return activeDays.join(', ');

  }

  getDailyShuttle(params) {
    const eDiv = document.createElement('div');
    const returnString = '10';
    eDiv.innerHTML += `<div title = "${returnString}">${returnString}</div>`;
    return eDiv;
  }

  getInterval(params) {
    const eDiv = document.createElement('div');
    const returnString = `${params.interval} min`;
    eDiv.innerHTML += `<div title = "${returnString}">${returnString}</div>`;
    return eDiv;
  }

  getJourneyStatus(params) {
    const eDiv = document.createElement('div');
    const returnString = params.status;
    eDiv.innerHTML += `<div title = "${returnString}">${returnString}</div>`;
    return eDiv;
  }

  getTimeDateForJourney(params) {
    const eDiv = document.createElement('div');
    const timeInHHmm = formatTimeCellToMin(parseInt(params.createdAt, 10));
    const returnString = getDate(parseInt(params.createdAt, 10));
    eDiv.innerHTML += `
    <div class="time-date"> 
    <div class="time" title = "${timeInHHmm} ${returnString}"> 10:00 <span class="time-am-pm"> AM </span></div>
    <div title = "${timeInHHmm} ${returnString}">${returnString}</div>
    </div>
    `;
    return eDiv;
  }

  getDatetimeAMPM(params) {
    const eDiv = document.createElement('div');
    const returnString = formatDateTimeAMPMCell(parseInt(params.lastServedDate, 10) + parseInt(params.lastServedTime, 10));
    eDiv.innerHTML += `<div title = "${returnString}">${returnString}</div>`;
    return eDiv;
  }

  getTimeDate(params) {
    let timeDateArr = params.tourDateTimeStr.split(',')
    let timeAMPM = timeDateArr[0].split(' ');
    const eDiv = document.createElement('div');
    eDiv.innerHTML += `
    <div class="time-date"> 
    <div class="time" title = "${timeDateArr[0]} ${timeDateArr[1]}"> ${timeAMPM[0]} <span class="time-am-pm"> ${timeAMPM[1]} </span></div>
    <div title = "${timeDateArr[0]} ${timeDateArr[1]}">${timeDateArr[1]}</div>
    </div>
    `;
    return eDiv;
  }

  getTimeInHHmm(time) {
    return moment(time.getTime()).format('HH:mm');
  }

  getTimeInMiliseconds(timeInSeconds) {
    let stopTime = new Date((moment().startOf('day').add(timeInSeconds, 'seconds')).valueOf());
    return stopTime;
  }

  getGridShuttleImage(data) {
    let profileImg = '';
    profileImg = AppSettings.GET_FILE_GRID_IMG_URL + data.vehicleImage;
    let lblPlane = `<div style="display:flex; flex-wrap: nowrap; align-items: center">
  
    <span class="shuttle-grid-img-name-cell" title="${data.busName}">${data.busName}</span>
    </div>`;
    const eDiv = document.createElement('div');
    eDiv.innerHTML = lblPlane;
    return eDiv;
  }

  getGridUserImage(data) {
    let profileImg = '';
    profileImg = AppSettings.GET_FILE_GRID_IMG_URL + data.profileImage;
    let lblPlane = `<div style="display:flex; flex-wrap: nowrap; align-items: center">
    
    <span class="shuttle-grid-img-name-cell" title="${data.fullName}">${data.fullName}</span>
    </div>`;
    const eDiv = document.createElement('div');
    eDiv.innerHTML = lblPlane;
    return eDiv;
  }

  getDriverStatus(data) {
    let color = data.driverBusy === true ? 'red' : 'green';
    let status = data.driverBusy === true ? 'Busy' : 'Available';

    let lblPlane = `<div style="text-align:center; color:${color}">${status}</div>`;
    const eDiv = document.createElement('div');
    eDiv.innerHTML = lblPlane;
    return eDiv;
  }

  getBusStatus(data) {
    let color = data.busBusy === true ? 'red' : 'green';
    let status = data.busBusy === true ? 'Busy' : 'Available';

    let lblPlane = `<div style="text-align:center; color:${color}">${status}</div>`;
    const eDiv = document.createElement('div');
    eDiv.innerHTML = lblPlane;
    return eDiv;
  }
  /* AEl End **/
  getBookingSource(param) {
    const eDiv = document.createElement('div');
    param.appBooking ? 'App' : 'Admin';
    const lblStatus = `<div class="booking-grid-table " title="">
    ${param.appBooking ? 'App' : 'Admin'}
    </div>`;
    let lblOnDemand = `<div class="booking-grid-table" style="font-weight: 500;" title="">
    ${param.onDemand ? 'Ride Now' : 'Ride Later'}
    </div>`;
    eDiv.innerHTML += lblStatus + lblOnDemand;
    return eDiv;
  }

  getDriver(params) {
    const driverName = params.driverName ? params.driverName.trim() ? params.driverName : 'NA' : 'NA';
    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table gid" title="">
        <div class="passengerName pb-2" title="${driverName}">${driverName}</div>
        <div class="vehicleInfo pb-2" title=" ${params.vehicleCode ? params.vehicleCode : ''} ${params.vehicleRegistration ? ` - ${params.vehicleRegistration}` : ''} ${params.vehicleModelName ? `(${params.vehicleModelName})` : ''}" >
          ${params.vehicleCode ? params.vehicleCode : ''}${params.vehicleRegistration ? ` - ${params.vehicleRegistration}` : ''}
          ${params.vehicleModelName ? `(${params.vehicleModelName})` : ''}
        </div>
        <div class="vehicleMakeModel" title="${params.driverVehicleType ? params.driverVehicleType : ''} ${params.vehicleCapacity ? ` (${params.vehicleCapacity})` : ''}">
          ${params.driverVehicleType ? params.driverVehicleType : ''} ${params.vehicleCapacity ? ` (${params.vehicleCapacity})` : ''}
        </div>
      </div>`;

    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getEventBasedLocationLatLng() {
    const selectedEventData: any = this.storageService.getItemFromSessionStorage('selectedEvent');
    if(selectedEventData) {
      return { lat: parseFloat(selectedEventData.latitude), lng: parseFloat(selectedEventData.longitude) }
    }
    return { lat: parseFloat(AppSettings.MAP_OPTIONS_POSITION.lat.toString()), lng: parseFloat(AppSettings.MAP_OPTIONS_POSITION.lng.toString()) }
  }

  getCitiesV1(eventId?): Observable<any> {
    return this.restApiService.get(`/secure/service-area/cities/v1?eventId=${eventId}`);
  }

  getAllCities(eventId?): Observable<any> {
    return this.restApiService.get(`/secure/service-area/cities/v1/all-cities?eventId=${eventId}`);
  }

  openMergePopup(data) {
    this.openMergePopupSubject.next({ bookingData: data });
  }

  assignDriverForMerge(data): Observable<any> {
    return this.restApiService.put('/secure/tour/assign-driver/merge', data, 'page-center');
  }

  reAssignDriverForMerge(data): Observable<any> {
    return this.restApiService.put('/secure/tour/reassign-driver/merge', data, 'page-center');
  }

  convertTimeAsPerTimeZone(inputTimeParam?, timeZone?) {
    let tz = '';
    if(timeZone) {
      tz = timeZone;
    } else if(this.storageService.getItemFromSessionStorage('storedTimezone')) {
      tz = this.storageService.getItemFromSessionStorage('storedTimezone');
    } else {
      tz = this.getTenantConfigValue(AppSettings.DEFAULT_TIMEZONE);
    }
    let dateTime = inputTimeParam ? new Date(inputTimeParam) : new Date();
    const tzDateTime = new Date(new Date(dateTime).toLocaleString('en-US', { timeZone: tz }));;
    return tzDateTime;
  }
  
  //** convert utcTimestamp to TZtimeStamp or date*/
  convertedTimeAsPerTz1(inputTimeParam?, form?) {
    const timeZone: string = this.storageService.getItemFromSessionStorage('storedTimezone');
    let tz = timeZone;
    let inputTime = inputTimeParam ? inputTimeParam : new Date();
    const utcDate = new Date(new Date(inputTime).toLocaleString('en-US', { timeZone: tz }));
    return utcDate;
  }

  convertedUTCTime(inputTimeParam) { // input dateTime and get converted TZ timestamp
    const browsertz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let returnVal
    let tz = this.storageService.getItemFromSessionStorage('storedTimezone');
    let machineTzOffset = this.getMachineAndTzOffset(browsertz, tz, inputTimeParam);

    if (machineTzOffset < 0) {
      returnVal = inputTimeParam.getTime() + (machineTzOffset * 60000);
    } else {
      returnVal = inputTimeParam.getTime() + (machineTzOffset * 60000);
    }
    return returnVal;
  }

  getMachineAndTzOffset(timeZone1, timeZone2, inputTimeParam?) {
    let date = inputTimeParam ? new Date(inputTimeParam) : new Date();
    const tz1 = new Date(date.toLocaleString('en-US', { timeZone: timeZone1 }));
    const tz2 = new Date(date.toLocaleString('en-US', { timeZone: timeZone2 }));
    return (tz1.getTime() - tz2.getTime()) / 6e4;
  }

    checkBulkImportStatus(eventid, screenCode?): Observable<any> {
    return this.restApiService.get(`/secure/file-import/inprogress-jobs/${eventid}?screenCode=${screenCode}`, 'page-center');
  }

  getMultipleStopDeatils(params) {
    let maxIntermediateStops = this.getTenantConfigValue(AppSettings.MAX_INTERMEDIATE_STOPS);
    if (maxIntermediateStops > 0) {

      if (params.stopOneAddress && params.stopOneLatitude && params.stopOneLongitude) {
        return `<div class='multi-stop'>${AppSettings.MULTIPLE_STOP}</div>`;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  getBookingIdwithMultiStop(params) {
    const mutiStop = this.getMultipleStopDeatils(params);
    const eDiv = document.createElement('div');
    const lblStatus = `<div class="booking-grid-table" title="">${params.tripId}</div>`;
    eDiv.innerHTML += lblStatus + mutiStop;
    return eDiv;
  }

  getMultiVehicleDeatils(params) {
    if (params.multivehicleBooking) {
      return `<div class='multi-stop'>${AppSettings.MULTIPLE_VEHICLE}</div>`;
    } else {
      return '';
    }
  }

    getInnerBookingsDetails(url): Observable<any> {
    return this.restApiService.get(url, 'page-center');
  }

  getVendorCompaniesList(eventId?): Observable<any> {
    return this.restApiService.get('/secure/vendor-companies/active/list?eventId=' + (eventId ? eventId : ''), 'page-center');
  }

  getLanguageSettings(): Observable<any> {
    return this.restApiService.get('/metadata/language-settings', 'page-center');
  }

  isAdditionalStopPresent(): boolean {
    return this.getTenantConfigValue(AppSettings.ADDITIONAL_STOPS) === '1';
  }

  getDedicatedBookingStatusClass(status: number) {
    switch (status) {
      case AppSettings.DEDICATED_BOOKING_STATUS_CODES.UPCOMING:
        return 'main-booking-status-upcoming';
      case AppSettings.DEDICATED_BOOKING_STATUS_CODES.ONGOING:
        return 'main-booking-status-ongoing';
      case AppSettings.DEDICATED_BOOKING_STATUS_CODES.COMPLETED:
        return 'main-booking-status-completed';
      case AppSettings.DEDICATED_BOOKING_STATUS_CODES.CANCELLATION:
        return 'main-booking-status-cancellation';
      case AppSettings.DEDICATED_BOOKING_STATUS_CODES.EXPIRED:
        return 'main-booking-status-expired';
      default:
        return 'main-booking-status-upcoming';
    }
  }

  getPredataBinding(formType: string, eventId: string, screenCode: string = ""): Observable<any> {
    return this.restApiService.get(`/secure/${formType}/add-update/predata?eventId=${eventId}&screenCode=${screenCode}`, 'page-center');
  }

  getTimezoneByLatLng(lat: number, lng: number): Observable<any> {
    const body = {
      latitude: lat,
      longitude: lng
    }
    return this.restApiService.post(`/secure/google-map/timezone`, body, 'page-center');
  }
}